import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';
export var BDCLogo = /*#__PURE__*/memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      circleFillColor = _ref.circleFillColor,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;

  var _useTheme = useTheme(),
      _useTheme$colors = _useTheme.colors,
      black = _useTheme$colors.black,
      primary = _useTheme$colors.primary,
      secondary = _useTheme$colors.secondary,
      white = _useTheme$colors.white;

  var circleFill = circleFillColor || secondary; // temporary, will be replaced by variants soon

  var fill = white;

  switch (color) {
    case 'navy':
      fill = primary;
      break;

    case 'black':
      fill = black;
      break;

    default:
      fill = white;
  }

  return /*#__PURE__*/React.createElement("svg", {
    height: height,
    width: width,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 42.2",
    style: {
      enableBackground: 'new 0 0 360 42.2'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M11.6,0.8v11.1c0,1.2,0,2.1-0.5,7.1h0.1c1.6-3.8,4.7-5.8,9.3-5.8c6.4,0,10.6,4.8,10.6,12.6 c0,9.4-5.2,16.2-15.4,16.2c-4.1,0-9.2-1-11.5-2.3V6.2H0V0.8H11.6z M11.4,34.9c1.1,0.6,3.1,1,4.7,1c4.8,0,7.6-3.9,7.6-9.4 c0-4.7-2.1-7.4-6-7.4c-4.1,0-6.3,2.7-6.3,6.8V34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M44.6,13.7v15.7c0,5,1.5,6.4,4.8,6.4c3.2,0,5.7-2.6,5.7-6.7V19.1h-3.5v-5.4h10.8v22.2h3.2v5.4H55.4 c0-3.2,0.3-5,0.7-5.7H56c-1.7,4.4-4.7,6.3-9.5,6.3c-6.4,0-9.3-4.1-9.3-9.4V19.1h-3.7v-5.4H44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M92.3,21.7h-6.6v-2.8c-1.5-0.5-2.8-0.8-4.3-0.8c-3.4,0-4.9,1.4-4.9,2.9c0,1.9,0.6,2,8.1,3 c6.5,0.9,9.2,3.2,9.2,8.3c0,5.8-4.6,9.5-13,9.5c-3.1,0-8.3-0.7-10.8-1.7v-7.7h6.6v3.2c1.3,0.4,3.4,0.9,4.9,0.9 c2.7,0,5.4-1.1,5.4-3.4c0-2.1-1.5-2.5-10-3.7c-5.1-0.7-7.2-3.3-7.2-7.4c0-5.7,4.7-9,12.1-9c2.9,0,6.5,0.4,10.7,1.8V21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M108.1,13.7v22.2h3.2v5.4H97.7v-5.4h3V19.1h-3.6v-5.4H108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M144.2,35.9h3.2v5.4h-13.5v-5.4h3V24.4c0-3.4-1.9-5-4.8-5c-4.2,0-6.4,2.9-6.4,7.1v9.4h3.2v5.4h-13.2v-5.4 h2.7V19.1h-3.6v-5.4h10.8c0,2.1,0,3.6-0.4,5.7h0.1c1.4-3.6,4.7-6.3,9.5-6.3c6.6,0,9.5,4.4,9.5,10.5V35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M157.6,29.2c0.2,4.4,3.5,7.1,8.8,7.1c3.4,0,5.6-0.5,8.8-1.9l-0.4,5.8c-3.4,1.3-6.4,1.7-10.1,1.7 c-9.6,0-15.2-5.6-15.2-14.3c0-8.8,5.5-14.5,13.8-14.5c8.2,0,13.3,5.5,13.3,16.1H157.6z M168.7,24.1c0-3.7-2.1-5.9-5.6-5.9 c-3.2,0-5.2,2.1-5.6,5.9H168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M203,21.7h-6.6v-2.8c-1.5-0.5-2.8-0.8-4.3-0.8c-3.4,0-4.9,1.4-4.9,2.9c0,1.9,0.6,2,8.1,3 c6.5,0.9,9.2,3.2,9.2,8.3c0,5.8-4.6,9.5-13,9.5c-3.1,0-8.3-0.7-10.8-1.7v-7.7h6.6v3.2c1.3,0.4,3.4,0.9,4.9,0.9 c2.7,0,5.4-1.1,5.4-3.4c0-2.1-1.5-2.5-10-3.7c-5.1-0.7-7.2-3.3-7.2-7.4c0-5.7,4.7-9,12.1-9c2.9,0,6.5,0.4,10.7,1.8V21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M230.8,21.7h-6.6v-2.8c-1.5-0.5-2.8-0.8-4.3-0.8c-3.4,0-4.9,1.4-4.9,2.9c0,1.9,0.6,2,8.1,3 c6.5,0.9,9.2,3.2,9.2,8.3c0,5.8-4.6,9.5-13,9.5c-3.1,0-8.3-0.7-10.8-1.7v-7.7h6.6v3.2c1.3,0.4,3.4,0.9,4.9,0.9 c2.7,0,5.4-1.1,5.4-3.4c0-2.1-1.5-2.5-10-3.7c-5.1-0.7-7.2-3.3-7.2-7.4c0-5.7,4.7-9,12.1-9c2.9,0,6.5,0.4,10.7,1.8V21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M274.6,22.5h-6.3v-3.7c-1.2-0.3-1.7-0.3-2.5-0.3c-4.3,0-6.9,3.7-6.9,8.3c0,5.5,3.2,9.2,8.7,9.2 c2.4,0,4.6-0.5,6.9-1.5l-0.4,6.2c-2.9,1-4.1,1.3-8.2,1.3c-9.1,0-14.4-5.9-14.4-14.4c0-8.8,5.7-14.4,14.5-14.4 c3.3,0,6.1,0.5,8.6,1.3V22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M292.3,41.9c-9.2,0-14.5-5.2-14.5-14.1c0-8.2,5.8-14.7,14.5-14.7c9.4,0,14.5,5.2,14.5,14.7 C306.7,36.1,300.9,41.9,292.3,41.9z M298.7,27.9c0-5.9-1.9-8.8-6.5-8.8c-3.8,0-6.4,2.9-6.4,8.8c0,5,1.9,7.9,6.5,7.9 C296.8,35.9,298.7,32.9,298.7,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M338.1,19.3c1.3-3.8,4.4-6.2,9.2-6.2c6.6,0,9.5,4.4,9.5,10.5v12.3h3.2v5.4h-13.2v-5.4h2.7V24.4 c0-3.4-1.9-5-4.8-5c-3.6,0-5.8,3.1-5.8,7.1v9.4h3.2v5.4h-13.2v-5.4h2.7V24.4c0-3.4-1.9-5-4.8-5c-3.7,0-5.8,3.1-5.8,7.1v9.4h3.2 v5.4h-13.5v-5.4h3V19.1h-3.6v-5.4h10.8c0,1.9,0,3.7-0.4,5.6h0.1c1.5-4,4.9-6.2,9.5-6.2c4.6,0,7.3,2.1,8.1,6.2H338.1z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: fill,
    cx: "104.2",
    cy: "4.6",
    r: "4.6"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: circleFill,
    cx: "242.1",
    cy: "37.4",
    r: "4.7"
  }))));
});